// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__2Kuog","tagText":"style_tagText__jDbrj"};